import { render, staticRenderFns } from "./MultiDetails.vue?vue&type=template&id=6e37648a&"
import script from "./MultiDetails.vue?vue&type=script&lang=js&"
export * from "./MultiDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports